import { createFileRoute } from "@tanstack/react-router";
import ThankYou from "@project/donate/pages/thank-you/$ref";

export const Route = createFileRoute("/donate/thank-you/$ref")({
  head: () => ({ meta: [{ title: "Thank You — Jivandhara" }] }),
  component: ThankYou,
});
